var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-btn', {
    directives: [{
      name: "scroll",
      rawName: "v-scroll",
      value: _vm.onScroll,
      expression: "onScroll"
    }],
    staticClass: "scroll-top",
    attrs: {
      "outlined": "",
      "fab": "",
      "tile": "",
      "fixed": "",
      "bottom": "",
      "right": "",
      "color": "#dadada",
      "transition": "slide-x-transition"
    },
    on: {
      "click": function click($event) {
        return _vm.$vuetify.goTo(_vm.target, _vm.options);
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-top-arrow"
  })]);
}
var staticRenderFns = []

export { render, staticRenderFns }